<template>
    <div>
        <div class="row" v-for="(chunk, i) in images" :key="i">
            <div class="gallery-padding" :class="generator.next().value" v-for="(image, j) in chunk" :key="j">
                <iframe class="gallery" v-if="image.filename == 'ARCH_10'" src='https://roundme.com/embed/269233/820213' frameborder='0' webkitallowfullscreen
                        mozallowfullscreen allowfullscreen></iframe>
                <a v-else :href="image.link" class="image-link">
                    <img :src="image.preview" class="gallery" :alt="image.filename">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import classGenerator from "../helpers";

    let gen = classGenerator()

    export default {
        name: "Gallery",
        props: ['imageUrls'],
        data() {
            return {
                generator: gen
            }
        },
        computed: {
            images() {
                let _imageUrls = []
                this.imageUrls.forEach((element) => {
                    let filename = _.split(element, '.')[0]
                    let extension = _.split(element, '.')[1]
                    let link = ''
                    if (filename.includes('video')) {
                        link = filename + '.m4v'
                    } else {
                        link = require("@/assets/images/" + filename + '.' + extension)
                    }

                    let _imgObj = {
                        link: link,
                        preview: require("@/assets/images/" + filename + '_prew.' + extension),
                        extension: extension,
                        filename: filename
                    }
                    _imageUrls.push(_imgObj)
                })
                _imageUrls = _.chunk(_imageUrls, 2)
                return _imageUrls
            }
        }
    }

</script>

<style scoped>
    .gallery-padding {
        padding: 0.1em 0.1rem
    }
</style>